import { Loading } from '@makyoapp/makyo-ui'

import { AppClientProvider, useAppClientContext } from '@/context/__project__/AppClientContext'
import { DbClientProvider } from '@/context/__project__/DbClientContext'
import { AppBrandKitProvider } from '@/context/AppBrandKitContext'
import { AppBuilderProvider } from '@/context/AppBuilderContext'
import { CurrentOrgProvider } from '@/context/CurrentOrgContext'
import { SingleProjectProvider, useSingleProjectContext } from '@/context/SingleProjectContext'
import { useParamId } from '@/hooks/useParamId'
import { LayoutLoading } from '@/components/Layout'

import { PageSync } from './PageSync'
import ProjectV2Routes from './routes'

function ProjectV2() {
  // access appClient for builder v2
  const { appClient, isAppClientLoading } = useAppClientContext()

  if (isAppClientLoading) {
    return <LayoutLoading title='' />
  }

  if (!appClient || !appClient.dbClient) {
    return <div>App Client Error</div>
  }

  const appID = appClient.appID as string
  const dbID = appClient.dbClient.dbID as string

  return (
    <DbClientProvider databaseID={dbID} appID={appID}>
      <AppBuilderProvider appClient={appClient}>
        <AppBrandKitProvider appClient={appClient}>
          <ProjectV2Routes />
          <PageSync />
        </AppBrandKitProvider>
      </AppBuilderProvider>
    </DbClientProvider>
  )
}

function ProjectDetail() {
  const { isLoading } = useSingleProjectContext()
  const appID = useParamId('project')

  return isLoading ? (
    <Loading fullHeight />
  ) : (
    <CurrentOrgProvider>
      <AppClientProvider appID={appID as string}>
        <ProjectV2 />
      </AppClientProvider>
    </CurrentOrgProvider>
  )
}

export default function ProjectV2Page() {
  return (
    <SingleProjectProvider>
      <div id='project-dashboard' className='w-full h-full'>
        <ProjectDetail />
      </div>
    </SingleProjectProvider>
  )
}
